export const scroll_action = (scroll) => ({
    type: 'SCROLL',
    payload: { 
        scroll: scroll
    }
  });
